import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AppService } from '@core/services/app.service';
import { ModalController } from '@ionic/angular';
import { IMekanlar, RezervasyonlarFilter } from '@models/dashboard';

@Component({
  selector: 'app-bookings-filter',
  templateUrl: './bookings-filter.component.html',
  styleUrls: ['./bookings-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingsFilterComponent implements OnInit {
  @Input() rezervasyonFilter: RezervasyonlarFilter;

  public mekanlar: IMekanlar[] = [{ mekanID: 11, mekanAdi: 'Tenis Kortu' }, { mekanID: 22, mekanAdi: 'Basketbol Sahası' }, { mekanID: 33, mekanAdi: 'Voleybol Sahası' }, { mekanID: 44, mekanAdi: 'Hobi Salonu' }, { mekanID: 55, mekanAdi: 'Futbol Sahası' }];

  constructor(
    public app: AppService,
    private modalController: ModalController,
  ) { }

  ngOnInit(): void { }

  onSelect(mekan: IMekanlar) {
    this.rezervasyonFilter.mekanID = this.rezervasyonFilter.mekanID === mekan.mekanID ? undefined : mekan.mekanID;
  }

  selectedFilter(mekanID: number) {
    this.modalController.dismiss({
      dismissed: true,
      mekanID
    });
  }

  async dismiss(dismissed: boolean) {
    await this.modalController.dismiss(dismissed);
  }

}
